import { render, staticRenderFns } from "./choice.vue?vue&type=template&id=66ac577a&"
import script from "./choice.vue?vue&type=script&lang=js&"
export * from "./choice.vue?vue&type=script&lang=js&"
import style0 from "./choice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports